<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item label="真实姓名" prop="contactName"  class="hide"   >
        <a-input v-model="form.contactName"  readOnly />
      </a-form-model-item>
      <a-form-model-item label="联系电话" prop="contactPhone" class="hide"  >
        <a-input v-model="form.contactPhone"  readOnly />
      </a-form-model-item>
      <a-form-model-item label="邮箱" prop="contactEmail" class="hide"  >
        <a-input v-model="form.contactEmail"  readOnly />
      </a-form-model-item>
      <a-form-model-item label="身份证号" prop="idCardNo" class="hide"  >
        <a-input v-model="form.idCardNo"  readOnly />
      </a-form-model-item>
      <a-form-model-item label="身份证国徽面" prop="idCardImgNational" class="hide"  >
        <oss-upload-single :disabled="true" :height="100" :width="100"  v-model="form.idCardImgNational" prefix="goods" type="img"/>
      </a-form-model-item>
      <a-form-model-item label="身份证人像面" prop="idCardImgFace" class="hide"  >
        <oss-upload-single :disabled="true" :height="100" :width="100"  v-model="form.idCardImgFace" prefix="goods" type="img"/>
      </a-form-model-item>
      <a-form-model-item label="是否审核通过" prop="isPass" >
        <a-radio-group v-model="form.isPass">
          <a-radio v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="!form.isPass" label="审核原因" prop="auditReason" >
        <a-input v-model="form.auditReason" placeholder="请输入审核原因 eg:通过/身份证信息有误" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAuthPersonal, addAuthPersonal, updateAuthPersonal } from '@/api/user/authPersonal'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssUploadSingle,
    CustomDictTag,
  },
  data () {
    return {
      //预览封面
      previewVisible: false,
      previewAvatar: '',
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        idList:null,
        contactName: null,

        contactPhone: null,
        contactEmail: null,
        idCardNo: null,

        idCardImgFace: null,

        idCardImgNational: null,

        isPass: null,

        auditReason: null,

        createTime: null,

        remark: null,
        localeFieldMap: {},

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        isPass: [
          { required: true, message: '审核状态不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        contactName: null,
        contactPhone: null,
        contactEmail: null,
        idCardNo: null,
        idCardImgFace: null,
        idCardImgNational: null,
        isPass: false,
        auditReason: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    handlePreview(file) {
      this.previewAvatar = file.url || file.preview;
      this.previewVisible = true;
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAuthPersonal({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '审核'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            var idList = [];
            idList.push(this.form.id);
            this.form.idList = idList;
            updateAuthPersonal(this.form).then(response => {
              this.$message.success(
                '审核成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addAuthPersonal(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.hide {
  /deep/ .ant-input {
    border: 0 !important;
  }
}
</style>